
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Skeleton, Tooltip } from 'antd'
import FlightOffers from './FlightOffers';
import { FaInfoCircle } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';

const BookingFilter = forwardRef(({
  applyDiscountShow,
  setApplyDiscountShow,
  discountAmountOffer,
  setDiscountAmountOffer,
  totalAfterDiscount,
  setTotalAfterDiscount,
  couponId,
  setCouponId,
  flightDetails,
  loading,
  totalAmount,
  totalPriceBaggages,
  mealTotalAmount,
  FlightOffersHideShow,
  convenienceCharge,
  calculatedFee,
  finalTotal,
  totalAmountReturn,
  mealTotalAmountRetrun,
  convenienceChargeTotalFareModal,
  totalSeatsPrice,
  totalSeatsPriceReturn
}, ref) => {

  let getUser = JSON.parse(localStorage.getItem('user'));
  let tokenId = JSON.parse(localStorage.getItem("tokenId"));
  const [appliedCheckLogin, setAppliedCheckLogin] = useState("");
  const [isValidCoupon, setValidCoupon] = useState(null);
  const [isCongratulations, setIsCongratulations] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const applyDiscount = () => {
    setCouponId(null);
    if (appliedCheckLogin?.type === "CASHBACK_OFFER") {
      let discountAmountOffer = 0;
      let totalAfterDiscounts = totalAmount;

      if (appliedCheckLogin?.discountType === "PERCENTAGE") {
        discountAmountOffer =
          (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
        if (discountAmountOffer < user_reward_points) {
          totalAfterDiscounts = totalAmount - discountAmountOffer;
          setCouponId(appliedCheckLogin?.id);
          setApplyDiscountShow(true);
          setIsCongratulations(true);
          setValidCoupon(null);

          setDiscountAmountOffer(discountAmountOffer);
          setTotalAfterDiscount(totalAfterDiscount);
        } else {
          setApplyDiscountShow(false);
          setIsCongratulations(false);
          setCouponId(null);
          setValidCoupon(
            "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
          );
        }
      } else if (appliedCheckLogin?.discountType === "AMOUNT") {
        discountAmountOffer = appliedCheckLogin?.discount || 0;
        if (discountAmountOffer < user_reward_points) {
          totalAfterDiscount = totalAmount - discountAmountOffer;
          setCouponId(appliedCheckLogin?.id);
          setApplyDiscountShow(true);
          setIsCongratulations(true);
          setValidCoupon(null);
          setDiscountAmountOffer(discountAmountOffer);
          setTotalAfterDiscount(totalAfterDiscount);
        } else {
          setCouponId(null);
          setApplyDiscountShow(false);
          setIsCongratulations(false);
          setValidCoupon(null);
          setValidCoupon(
            "We’re sorry, but it seems your account balance is insufficient to redeem this coupon."
          );
        }
      }
    } else {
      const totalAmount = Math.round(totalPriceBaggages);
      let discountAmountOffer = 0;
      let totalAfterDiscount = totalAmount;

      if (appliedCheckLogin?.discountType === "PERCENTAGE") {
        discountAmountOffer =
          (totalAmount * (appliedCheckLogin?.discount || 0)) / 100;
        totalAfterDiscount = totalAmount - discountAmountOffer;
      } else if (appliedCheckLogin?.discountType === "AMOUNT") {
        discountAmountOffer = appliedCheckLogin?.discount || 0;
        totalAfterDiscount = totalAmount - discountAmountOffer;
      }
      setApplyDiscountShow(true);
      setIsCongratulations(true);
      setCouponId(appliedCheckLogin?.id);
      setDiscountAmountOffer(discountAmountOffer);
      setTotalAfterDiscount(totalPriceBaggages);
    }
  };

  return (
    <>
      <div className="booking-filter sticky-cls-top">
        <Skeleton
          paragraph={{ rows: 6, }}
          loading={loading}
          style={{ background: "#fff" }}
          className='p-4 mb-4'
        >
          <div className='card mb-2'>
            <div className="card-body">
              <h3 className="mb-2 fw-bold">Payment Detail </h3>

              <ul className='price-details'>
                {flightDetails?.flightDetails?.fareRules?.ADULT > 0 && (
                  <li className="d-flex justify-content-between">
                    {flightDetails?.flightDetails?.fareRules?.ADULT === 1 ? "Adult" : "Adults"} * {flightDetails?.flightDetails?.fareRules?.ADULT}
                    <span>₹{(flightDetails?.flightDetails?.fareRules?.ADULT_BF || 0)}</span>
                  </li>
                )}

                {flightDetails?.flightDetails?.fareRules?.CHILD > 0 && (
                  <li className="d-flex justify-content-between">
                    {flightDetails?.flightDetails?.fareRules?.CHILD === 1 ? "Child" : "Children"} * {flightDetails?.flightDetails?.fareRules?.CHILD}
                    <span>₹{(flightDetails?.flightDetails?.fareRules?.CHILD_BF || 0)}</span>
                  </li>
                )}

                {flightDetails?.flightDetails?.fareRules?.INFANT > 0 && (
                  <li className="d-flex justify-content-between">
                    {flightDetails?.flightDetails?.fareRules?.CHILD === 1 ? "Infant" : "Infants"}  * {flightDetails?.flightDetails?.fareRules?.INFANT}
                    <span>₹{(flightDetails?.flightDetails?.fareRules?.INFANT_BF || 0)}</span>
                  </li>
                )}

                <li className='d-flex justify-content-between'>Tax & Surcharges <span>₹{flightDetails?.flightDetails?.fareRules?.taxFare}</span></li>


                {(mealTotalAmount > 0 || mealTotalAmountRetrun > 0) && (
                  <li className='d-flex justify-content-between'>
                    Meal <span>₹{mealTotalAmount + mealTotalAmountRetrun}</span>
                  </li>
                )}

                {(totalAmount > 0 || totalAmountReturn > 0) && (
                  <li className='d-flex justify-content-between'>
                    Baggage <span>₹{totalAmount + totalAmountReturn}</span>
                  </li>
                )}

                {(totalSeatsPrice > 0 || totalSeatsPriceReturn > 0) && (
                  <li className='d-flex justify-content-between'>
                    Seats <span>₹{totalSeatsPrice + totalSeatsPriceReturn}</span>
                  </li>
                )}

                {applyDiscountShow && discountAmountOffer > 0 && (
                  <li className="d-flex justify-content-between">
                    Discount <span className="text-danger">₹{Math.round(discountAmountOffer)}</span>
                  </li>
                )}

              </ul>

              <div className='text-center mt-2 bg-light-success p-2 rounded'>
                {!applyDiscountShow ? (
                  <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalPriceBaggages)}</span></h3></>) : (
                  <><h3 className='d-flex justify-content-between'>Total : <span style={{ fontWeight: 'bold' }}>₹{Math.round(totalPriceBaggages - discountAmountOffer)}</span></h3></>
                )}
              </div>
            </div>
          </div>

          {(!tokenId || getUser?.reward_point <= "0.00") &&
            <div className='card mb-2'>
              <div className="card-header py-3">

                <h3 className='mb-2 fw-bold'>Exclusive Cashback for New Users</h3>

                <ul className='price-details'>
                  <li className="d-flex align-items-center justify-content-between">
                    <p>Reward Points</p>
                    <h2 className=' d-flex align-items-center mt-1'>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" className='me-1' fill='var(--primary-color)'>
                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                        <g id="SVGRepo_iconCarrier">
                          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
                        </g>
                      </svg>
                      {!convenienceChargeTotalFareModal ? (
                        Math.round(totalPriceBaggages - Number(discountAmountOffer))
                      ) : (
                        Math.round(finalTotal - Number(discountAmountOffer))
                      )}

                    </h2>
                  </li>
                </ul>
              </div>
            </div>
          }

        </Skeleton>


        {/* {FlightOffersHideShow && */}
        <Skeleton
          paragraph={{ rows: 4, }}
          loading={loading}
          style={{ background: "#fff" }}
          className='p-4 mb-4'
        >

          <FlightOffers
            ref={ref}
            totalPriceBaggages={totalPriceBaggages}
            setDiscountAmountOffer={setDiscountAmountOffer}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
            appliedCheckLogin={appliedCheckLogin}
            setAppliedCheckLogin={setAppliedCheckLogin}
            applyDiscount={applyDiscount}
            totalAfterDiscount={totalAfterDiscount}
            setApplyDiscountShow={setApplyDiscountShow}
            applyDiscountShow={applyDiscountShow}
            isCongratulations={isCongratulations}
            setIsCongratulations={setIsCongratulations}
            isValidCoupon={isValidCoupon}
            setValidCoupon={setValidCoupon}
          />
        </Skeleton>
        {/* } */}
      </div>
    </>
  );

});

export default BookingFilter
